import {HTTP} from '../../../http-common'
import helper from '../index'

export default {
  getEvents: async(charityId) => {
    let headers = helper.setHeaders()
    const res = await HTTP.get(`/charity-events/${charityId}`, {
      headers
    })
    return res.data.data
  },
  getAdminEvents: async(charityId) => {
    let headers = helper.setHeaders()
    const res = await HTTP.get(`/charity-events/event-detail/${charityId}`, {
      headers
    })
    return res.data.data
  },
  
  updateEvent: async({
    charityEventId,
    logo,
    need,
    mount_required,
    start,
    end,
    description
  }) => {
    let formData = new FormData()
    let headers = helper.setHeaders()
    headers['Content-Type'] = 'multipart/form-data'
    formData.append('need', need)
    formData.append('mount_required', mount_required)
    formData.append('start', start)
    formData.append('end', end)
    formData.append('description', description)
    formData.append('logo', logo)
    formData.append('_method', 'PUT')
    const response = await HTTP.post(
      `/charity-events/${charityEventId}`,
      formData,
      {
        headers: headers
      }
    )
    return response.data.data
  },
  createEvent: async({
    logo,
    need,
    mount_required,
    start,
    end,
    description
  }) => {
    let formData = new FormData()
    let headers = helper.setHeaders()
    headers['Content-Type'] = 'multipart/form-data'
    formData.append('need', need)
    formData.append('mount_required', mount_required)
    formData.append('start', start)
    formData.append('end', end)
    formData.append('description', description)
    formData.append('logo', logo)
    const response = await HTTP.post('/charity-events', formData, {
      headers: headers
    })
    return response.data.data
  },
  deleteEvent: async(id) => {
    const headers = helper.setHeaders()
    const res = await HTTP.delete(`/charity-events/${id}`, {
      headers
    })
    return res
  },
  uploadLogo: async(logo, charityEventId) => {
    const res = await HTTP.post(
      `/charity-events/upload/${charityEventId}`,
      logo
    )
    return res
  },
  showEvent: async() => {
    const res = await HTTP.get(`/charity-events/0`, {
      headers: helper.setHeaders()
    })
    return res.data.data
  }
}
